import styles from './notificacoes.module.scss';
import Mensagem from '../mensagem/mensagem';
import { IMensagem } from '../../../interfaces/IMensage';

function Notificacoes({ mensagens }: { mensagens: IMensagem[] | undefined }) {
  return (
    <div className={styles.mensagem}>
      {mensagens?.map((mensagem, id) => (
        <Mensagem key={id} tipo={mensagem.tipo} chaveUnica={id} conteudo={mensagem?.mensagem} />
      ))}
    </div>
  );
}

export default Notificacoes;
